import FormContainerView from "./FormContainerView";

function FormContainer({
  header,
  children,
  onCancel,
  onSubmit,
  submitError,
  submitLoadingGroup,
  actions,
  formId,
}) {
  return (
    <FormContainerView
      header={header}
      onCancel={onCancel}
      onSubmit={onSubmit}
      submitError={submitError}
      submitLoadingGroup={submitLoadingGroup}
      actions={actions}
      formId={formId}
    >
      {children}
    </FormContainerView>
  );
}

export default FormContainer;
